import React, { useContext } from 'react';
import BoardingContext from 'components/navigation/boarding/boardingContext';
import BoardingHelper from 'components/navigation/boarding/boardingHelper';
import Helpers from 'utils/helpers';

export default function BoardingStepsMenu(props) {
  const { boardingState } = useContext(BoardingContext);
  const step = boardingState.step;

  if (step === BoardingHelper.enums.steps.StepsMenu) {
    return <StepsMenuControl />;
  }

  return null;
}

function StepsMenuControl(props) {
  const { boardingState, setStep } = useContext(BoardingContext);

  const handleDealerClicked = () => {
    setStep(BoardingHelper.enums.steps.DealerSelection);
  };

  const handleStoreClicked = () => {
    if (boardingState.store.isComplete) {
      setStep(BoardingHelper.enums.steps.StoreDetails);
    }
    else {
      setStep(BoardingHelper.enums.steps.StoreKeyEntry);
    }
  };

  const handleUserClicked = () => {
    if (boardingState.user.isComplete) {
      setStep(BoardingHelper.enums.steps.UserDetails);
    }
    else {
      setStep(BoardingHelper.enums.steps.UserEmailEntry);
    }
  };

  const renderDealerResults = () => {
    if (boardingState.dealer.isComplete) {
      return (
        <>
          <div>{boardingState.data.dealer?.companyName}</div>
          <div>{boardingState.data.dealer?.branchName}</div>
        </>
      )
    }
    return null;
  };

  const renderStoreResults = () => {
    if (boardingState.store.isComplete) {
      return (
        <>
          <div>{boardingState.data.store?.name}</div>
        </>
      )
    }
    return null;
  };

  const renderUserResults = () => {
    if (boardingState.user.isComplete) {
      return (
        <>
          <div>{boardingState.data.user?.firstName} {boardingState.data.user?.lastName}</div>
        </>
      )
    }
    return null;
  };

  return (
    <div className='boarding-steps row'>
      <StepControl
        title='Dealer'
        number='1'
        iconClass='icons8-pos-terminal-2'
        onClick={handleDealerClicked}
        isComplete={boardingState.dealer.isComplete}
        isEditable={boardingState.dealer.isEditable}
        results={renderDealerResults()}
      />
      <StepControl
        title='Store'
        number='2'
        iconClass='icons8-online-shop-2'
        onClick={handleStoreClicked}
        isComplete={boardingState.store.isComplete}
        isEditable={boardingState.store.isEditable}
        results={renderStoreResults()}
      />
      <StepControl
        title='User'
        number='3'
        iconClass='icons8-user'
        onClick={handleUserClicked}
        isComplete={boardingState.user.isComplete}
        isEditable={boardingState.user.isEditable}
        results={renderUserResults()}
      />
    </div>
  );
}

function StepControl(props) {
  const handleClick = () => {
    if (props.isEditable && props.onClick) {
      props.onClick();
    }
  };

  const renderResults = () => {
    if (props.results) {
      return <div className='boarding-step-results text-center'>{props.results}</div>;
    }
    else {
      return null;
    }
  };

  const renderLink = () => {
    if (!props.isEditable) {
      return null;
    }
    else if (props.isComplete) {
      return <div className='boarding-step-action text-link'><i className='icons8-edit' /> Modify</div>;
    }
    else {
      return <div className='boarding-step-action text-link'><i className='icons8-right' /> Get Started</div>;
    }
  };

  const getClass = () => {
    let classNames = ['boarding-step', props.className];
    if (props.isComplete) {
      classNames.push('bg-light-success');
    }
    if (props.isEditable) {
      classNames.push('active');
    }
    return Helpers.String.join(classNames);
  };

  return (
    <div className='col-12 col-lg-4 my-2'>
      <div className={getClass()} onClick={handleClick}>
        <div className='boarding-step-number'>{props.number}</div>
        <div className='boarding-step-icon'><i className={props.iconClass} /></div>
        <div className='boarding-step-title'>{props.title}</div>
        {renderResults()}
        {renderLink()}
      </div>
    </div>
  );
}